import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.css']
})
export class PaymentMethodsComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();

  topTooltipExcel: string = 'Download .xlsx';

  dataItem: any = {
    chart: {
      aligncaptionwithcanvas: "0",
      plottooltext:
        "<b>$dataValue</b>",
      theme: "gammel",
      decimalSeparator: ",",
      thousandSeparator: ".",
      showvalues: "1",
      placevaluesinside: "0"
    },
    data: []
  };

  width = '100%';
  height = '320';
  type = 'bar2d';
  dataFormat = 'json';
  dataSource = this.dataItem;
  loading: boolean = true;
  dateFirst!: any;
  errorApi = false;
  message : string = "";

  constructor(private api: ApiService) { }

  ngOnInit() {
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    if (item.branch != undefined) {
      this.paymentMethod(item).subscribe(data => {
        try {
          this.dataItem.data = [];
          let excelInfo = [];
          if (data.dataRow.length != 0) {
            data.dataRow.map((el:any) => {
              this.dataItem.data.push({
                'label': el.payment_document_type,
                'value': el.payment_value
              })
              excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Código Filiais': item.branch.toString(), 'Tipo': el.payment_document_type.toString(), 'Valor': 'R$' + el.payment_value.toString()});
            })
            excelInfo.unshift({});
            localStorage.setItem('payment-methods', JSON.stringify(excelInfo));
            this.errorApi = false;
          } else {
            this.message = CONSTANTS.MESSAGES.DATA_NULL_PAYMENT_METHODS;
            this.formatErrorMensagem(this.message);
            this.errorApi = true;
          }
          this.loading = false;
        } catch (error: unknown){
          this.loading = false;
          if (error instanceof Error)
            this.formatErrorMensagem(error.message);
        }
      }, error => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_PAYMENT_METHODS;
        this.formatErrorMensagem(error.message);
      })
    }
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataPaymentMethods = [];
    let objectPaymentMethods = localStorage.getItem('payment-methods');

    objectPaymentMethods != null
      ? (dataPaymentMethods = JSON.parse(objectPaymentMethods))
      : (dataPaymentMethods = []);
    const worksheetPaymentMethods= XLSX.utils.json_to_sheet(dataPaymentMethods);

    const workbook = {
      Sheets: {
        'formas-pagamento': worksheetPaymentMethods,
      },
      SheetNames: [
        'formas-pagamento',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-formas-pagamento' + EXCEL_EXTENSION);
  }

  paymentMethod(item: any) {
    return this.api.postDocumentType(item.dataMin, item.dataMax, item.branch, item.sellers);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: payment-methods \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
